<div *ngFor="let item of jsonItems" class="mb-2">
    <span [innerHTML]="item"></span>
</div>
